import { Injectable } from "@angular/core";
import { HttpBackend } from "@angular/common/http";
import { CfgService } from "../../../../cfg/cfg.service";
import { ServerAddressesCfgService } from "src/app/util/serverAddressesCfg.service";

export class DiscontinuousPermanentWorkersCfg {
  public summaryEndpointPattern: string;
  public detailEndpointPattern: string;
}

export class DiscontinuousPermanentWorkersKpiCfg {
  public discontinuousPermanentWorkers: DiscontinuousPermanentWorkersCfg;
  public urlTalent: string;
}

@Injectable()
export class DiscontinuousPermanentWorkersKpiCfgService extends CfgService<DiscontinuousPermanentWorkersKpiCfg> {
  json: any = {
    discontinuousPermanentWorkers: {
      summaryEndpointPattern: "%{DashboardApiUrl}/discontinuous/{0}?date={1}",
      detailEndpointPattern: "%{DashboardApiUrl}/discontinuous/{0}/detail?date={1}"
    },
    urlTalent: "%{TalentApiUrl}/#/"
  }

  constructor(httpBackend: HttpBackend, private serverAddressesCfgService: ServerAddressesCfgService) {
    super(httpBackend);
  }

  protected getCfgFile(): string {
    return `/cfg/kpi/discontinuousPermanentWorkersKpi.cfg.json`;
  }

  /**
* Carga las url en el json
*/
  loadDataUrl() {
    this.replacePlaceholders(this.json, this.serverAddressesCfgService.getData());
  }
}
